import React, { Component } from 'react';
import Login from './pages/Login';
import MenuLayout from './pages/MenuLayout';
import { Redirect, Route, Switch, HashRouter as Router } from 'react-router-dom';
import './App.css';
import 'antd/dist/reset.css';
import 'antd-button-color/dist/css/style.css';
import { load_profile } from './redux/actions/profile'
import { connect } from 'react-redux'
import CustomerForm from './pages/customer/CustomerForm';
import Profile from './pages/Profile';
import UserList from './pages/user/UserList';
import BranchList from './pages/branch/BranchList';
import RouteList from './pages/route/RouteList';
import RouteDetail from './pages/route/RouteDetail';
import CustomerDetail from './pages/customer/CustomerDetail';
import ProductList from './pages/product/ProductList';
import PageNotFound from './pages/PageNotFound';
import MapView from './pages/mapView/MapView';
import ExportExcel from './pages/excel/ExportExcel';
import { Helmet } from "react-helmet";

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            errorToasterVisible: false,
            errorToasterTitle: "",
            errorToasterMessage: ""
        }
        this.getReactRoutes = this.getReactRoutes.bind(this)
    }

    componentDidMount() {
        const { dispatch } = this.props
        dispatch(load_profile())
    }

    getReactRoutes() {
        const {profile} = this.props
        const siteRoutes = []
        siteRoutes.push(<Route key="excel_data" path="/excel_data" render={() => <MenuLayout displayComponent={<ExportExcel />} selectedMenu={"excel_data"} />} />)
        siteRoutes.push(<Route key="map_view" path="/map_view" render={() => <MenuLayout displayComponent={<MapView />} selectedMenu={"map_view"} />} />)
        siteRoutes.push(<Route key="customer_create" path="/routes/:routeId/customer_create" render={() => <MenuLayout displayComponent={<CustomerForm mode="CREATE" />} selectedMenu={"customer_create"} />} />)
        siteRoutes.push(<Route key="customer_edit" path="/routes/:routeId/customer_edit/:id" render={() => <MenuLayout displayComponent={<CustomerForm mode="EDIT" />} selectedMenu={"customer_edit"} />} />)
        siteRoutes.push(<Route key="customer_detail" path="/routes/:routeId/customer_detail/:id" render={() => <MenuLayout displayComponent={<CustomerDetail />} selectedMenu={"customer_detail"} />} />)
        siteRoutes.push(<Route key="route_detail" path="/routes/:id" render={() => <MenuLayout displayComponent={<RouteDetail />} selectedMenu={"route_detail"} />} />)
        if (profile.profile.current_branch && ["ADMIN", "BRANCH_MANAGER"].includes(profile.profile.role)) {
            siteRoutes.push(<Route key="routes" path="/routes" render={() => <MenuLayout displayComponent={<RouteList />} selectedMenu={"routes"} />} />)
        }
        return siteRoutes
    }

    render() {
        const {profile} = this.props
        return (
            <div className="application">
                <Helmet>
                    <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1"/>
                </Helmet>
                <Router>
                    <Switch>
                        <Route key="login" exact path="/login" render={() => <Login />} />
                        { profile.profile.role === "ADMIN" ? <Route key="users" path="/users" render={() => <MenuLayout displayComponent={<UserList />} selectedMenu={"users"} />} /> : null }
                        { profile.profile.role === "ADMIN" ? <Route key="branches" path="/branches" render={() => <MenuLayout displayComponent={<BranchList />} selectedMenu={"branches"} />} /> : null }
                        { profile.profile.role === "ADMIN" ? <Route key="products" path="/products" render={() => <MenuLayout displayComponent={<ProductList />} selectedMenu={"products"} />} /> : null }
                        <Route key="profile" path="/profile" render={() => <MenuLayout displayComponent={<Profile />} selectedMenu={"profile"} />} />
                        <Route key="page_not_found" path="/page_not_found" render={() => <MenuLayout displayComponent={<PageNotFound />} selectedMenu={"page_not_found"} />} />
                        {/* <Route key="login" path="/" render={() => <MenuLayout/> } /> */}
                        {this.getReactRoutes()}
                        <Route key="*" path="*" render={() => <MenuLayout displayComponent={<PageNotFound />} selectedMenu={"page_not_found"} />} />
                        {/* <Route key="login" path="*" element={<PageNotFound />} /> */}
                        {/* <Route key="login" render={() => <Redirect to="/routes" />} /> */}
                    </Switch>
                </Router>
            </div>

            
        )
    }
}

const mapStateToProps = state => ({
    profile: state.profile
})


export default connect(mapStateToProps)(App);

